import { gql } from '@apollo/client';

export const POST_REPORTS = gql`
  query postReports($postId: ID!) {
    postReports(postId: $postId) {
      post {
        id
        username
        author {
          avatarUrl
        }
        textBlocks {
          id
          type
          data {
            paragraph
            header
            level
            code
            caption
            # List blocks
            style
            items {
              id
              text
            }
            # Image blocks
            file {
              url
              originalName
              type
              size
            }
            withBorder
            withBackground
            stretched
          }
        }
        postAnalytics {
          id
          metrics {
            replyCount
            bookmarkCount
            votesCount {
              upVotes
              downVotes
            }
          }
        }
        createdAt
      }
      reports {
        id
        postId
        reporterId
        reporterUsername
        reason
        category
        details
        createdAt
        status
        assignedModeratorId
        assignedModeratorUsername
        assignedAt
      }
    }
  }
`;
